module.exports = __webpack_public_path__ + "static/media/DefenderNetwork.660291ba.png";